import React from "react";
import PrimaryButton from "../shared/primaryButton";
import { createCart, log } from "../../utils/api";
import { $isSideCartOpen, $productAddToCart } from "../../utils/store";
import { gtag } from "../../utils/utils";
import { Product } from "../../utils/types";
import { __t } from "../../utils/translate";
import TiktokPixel from 'tiktok-pixel';
import { addProductToCartStore } from "../../utils/store";
import { useProductContext } from "@/providers/productProvider";

import Card from "@/images/icons/card.svg";
import { useOptions } from "@/hooks/useOptions";
import { navigate } from "gatsby";

type AddToCartButtonProps = {
    className?: string;
    classNameWrapper?: string;
    textStyle?: string;
    productName?: string;
    product: Product;
    variationId: number;
    productPrice: number;
    quantity: number;
    cardAnimation?: boolean;
    bundle?: { products: Record<string, Product>; };
    buttonText?: string;
    isCoupon?: boolean;
};

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
    className = "",
    classNameWrapper = "",
    textStyle,
    productName,
    product,
    variationId,
    productPrice,
    quantity,
    bundle = {},
    cardAnimation = false,
    buttonText = "Add to cart",
    isCoupon = false,
}) => {
    const variation = product.variations_product.find(v => v.id === variationId);
    const image = variation ? variation.image : product.image;
    const { isOutOfStock } = useProductContext();
    const options = useOptions();
    const currency = options.wpOptions.data.currency;

    let attribute_summary = '';
    const attributes = {};
    if (variation) {
        variation.attributes2.map(attr => {
            attribute_summary = attribute_summary + attr.attribute_label + ': ' + attr.value_label + ', ';
            attributes[`attribute_${attr.attribute}`] = { label: attr.attribute_label, value: attr.value_label }
        })
    }

    const bundled_items = product.bundled_items?.map(item => {
        return { id: item.product?.wordpress_id, name: item.product?.name, quantity: item.quantity_default };
    });

    let price = variation
        ? variation.sale_price ? variation.sale_price : variation.regular_price ? variation.regular_price : variation.price
        : product.sale_price ? product.sale_price : product.regular_price ? product.regular_price : product.price;

    const new_product = {
        image: image,
        key: 0,
        line_subtotal: '',
        line_subtotal_tax: 0,
        line_tax: product.name,
        line_tax_data: { subtotal: Array(0), total: Array(0) },
        line_total: price,
        name: product.name,
        price: price,
        product_id: product.wordpress_id,
        quantity: 1,
        slug: "",
        variation: attributes,
        variation_id: variationId,
        bundled_items: bundled_items
    };

    const handleAddToCart = () => {
        $productAddToCart.set(true);

        const body = {
            product_id: variationId,
            quantity: quantity,
            ...bundle
        };

        const gtag_add_to_cart_data = {
            items: [{
                item_id: product.sku,
                slug: product.slug,
                item_name: product.name,
                // item_brand: 'Ortorex',
                price: price,
                quantity: quantity,
                currency: currency,
                item_category: product?.categories?.length ? product.categories[0].name : '',
                item_variant: attribute_summary
            }],
            event_callback: function () {
                console.log('add_to_cart completed');
                log('gtag-completed', `add_to_cart`, {});
            }
        };
        gtag("event", "add_to_cart", gtag_add_to_cart_data);

        if (typeof window !== "undefined" && !!window?.fbq) {
            const fbq_add_to_cart_data = {
                content_ids: [variationId],
                content_name: productName,
                contents: [{ id: variationId, quantity: quantity }],
                value: quantity * productPrice,
            };
            window.fbq('track', 'AddToCart', fbq_add_to_cart_data);
            log('fbq', 'track-AddToCart', fbq_add_to_cart_data);
        }

        if (process.env.GATSBY_TIKTOK && typeof TiktokPixel !== "undefined") {
            const tiktok_add_to_cart_data = {
                content_id: [variationId],
                content_name: productName,
                value: quantity * productPrice,
            };
            TiktokPixel.track('AddToCart', tiktok_add_to_cart_data);
            log('tiktok', 'track-AddToCart', tiktok_add_to_cart_data);
        }

        addProductToCartStore(new_product);

        if (buttonText === "Buy Now") {
            createCart(body);
            gtag("event", "checkout");
            navigate("/checkout");
        } else {
            $isSideCartOpen.set(true);
            createCart(body);
        }


        // createCart(body).then(() => $isSideCartOpen.set(true));
    };

    return (
        <div data-cy={`${isCoupon ? 'coupon_add_to_cart' : 'add_to_cart'}`} className={`${classNameWrapper} relative ${isOutOfStock ? 'opacity-[0.5] cursor-no-drop' : 'cursor-pointer'}`} onClick={!isOutOfStock ? handleAddToCart : () => { }} >

            {!!cardAnimation &&
                <div className="absolute top-0 left-0 w-full flex justify-center">
                    <img
                        className="w-[72px] card-animation"
                        src={Card}
                        alt=""
                    />

                </div>
            }

            <PrimaryButton testid="addToCart" textStyle={textStyle} className={`single_add_to_cart_button ${className} ${isOutOfStock ? 'pointer-events-none' : ''} z-[1] relative px-[25px] ${cardAnimation ? "card-animation-button" : ''}`} >
                <span className={`font-poppins ${cardAnimation ? "opacity-0" : ''}`}>{__t(buttonText)}</span>
            </PrimaryButton>

            {!!cardAnimation &&
                <div className="absolute top-0 left-0 h-full w-full flex justify-center z-[2] items-center">
                    <div className="card-animation-text font-poppins text-18 text-white">{__t(buttonText)}</div>
                </div>
            }


        </div>
    );
};

export default AddToCartButton;
